<template>
    <svg class="ath-visual-rating"
        v-if="fillWidth !== false"
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="`0 0 ${$options.WIDTH} ${$options.HEIGHT}`"
        :style="{height: '2rem', width: 'auto', aspectRatio: `${$options.WIDTH} / ${$options.HEIGHT}`, display: 'block'}">
        <path v-for="i in 5"
            :key="`empty-${i}`"
            fill="#CCC"
            :d="$options.STAR"
            :transform="`translate(${(i - 1) * $options.STAR_SPACING} 0)`" />
        <!-- Nested svg clips the filled stars to the rating width -->
        <svg v-if="fillWidth > 0" :width="fillWidth" :height="$options.HEIGHT">
            <path v-for="i in 5"
                :key="`full-${i}`"
                fill="#efc529"
                :d="$options.STAR"
                :transform="`translate(${(i - 1) * $options.STAR_SPACING} 0)`" />
        </svg>
    </svg>
</template>

<script>
import { isNumber } from '@aretheyhappy/utils';

export default {
    name: 'mead-rating',
    WIDTH: 382.32,
    HEIGHT: 59.476,
    //  Distance between the left edge of each star
    STAR_SPACING: 79.78,
    //  Horizontal centre of a star, where a half star is split
    STAR_HALF: 31.599,
    STAR: [
        'M50.91 59.688c-.288 0-.576-.069-.837-.212L31.599 49.402 13.126 59.476a1.758 1.758 0 0 1-2.57-1.834',
        'l3.364-20.175L.515 24.062a1.758 1.758 0 0 1-.432-1.776 1.76 1.76 0 0 1 1.384-1.198l20.185-3.364',
        'L30.03.969a1.756 1.756 0 0 1 3.138 0l8.378 16.755 20.185 3.364a1.756 1.756 0 0 1 .953 2.974',
        'L49.278 37.466l3.364 20.175a1.773 1.773 0 0 1-.713 1.721 1.783 1.783 0 0 1-1.019.326z',
    ].join(''),
    props: {
        /**
         * Star rating value, clamped to a 0-5 range. Rendered as five stars filled to
         * the value rounded down to the nearest half-star. Defaults to `false`, which
         * renders nothing.
         */
        value: {type: [Boolean, Number], default: () => false},
    },
    computed: {
        fillWidth: function () {
            if (!isNumber(this.value)) return false;

            let s_val = this.value;
            if (s_val < 0) s_val = 0;
            if (s_val > 5) s_val = 5;

            const whole = Math.floor(s_val);
            const half = s_val % 1 >= 0.5 ? this.$options.STAR_HALF : 0;
            return whole * this.$options.STAR_SPACING + half;
        },
    },
};
</script>
